import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faSync, faPlus } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import './ProveedoresData.css';
import baseURL from '../../url';

export default function ProveedoresData() {
    const [proveedores, setProveedores] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [proveedorActual, setProveedorActual] = useState({});
    const [nombre, setNombre] = useState('');
    const [correo, setCorreo] = useState('');
    const [telefono, setTelefono] = useState('');
    const [direccion, setDireccion] = useState('');
    const [filtro, setFiltro] = useState('');

    useEffect(() => {
        cargarProveedores();
    }, []);

    const cargarProveedores = () => {
        fetch(`${baseURL}/inventarioProveedoresGet.php`)
            .then(response => response.json())
            .then(data => setProveedores(data.proveedores || []))
            .catch(error => console.error('Error:', error));
    };

    const abrirModalNuevo = () => {
        setProveedorActual({});
        setNombre('');
        setCorreo('');
        setTelefono('');
        setDireccion('');
        setModalVisible(true);
    };

    const abrirModalEditar = (proveedor) => {
        setProveedorActual(proveedor);
        setNombre(proveedor.nombre);
        setCorreo(proveedor.correo || '');
        setTelefono(proveedor.telefono || '');
        setDireccion(proveedor.direccion || '');
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const guardarProveedor = () => {
        if (!nombre) {
            toast.error('El nombre es obligatorio');
            return;
        }

        if (proveedorActual.idProveedor) {
            // Editar
            const payload = { nombre, correo, telefono, direccion };
            fetch(`${baseURL}/inventarioProveedoresPut.php?idProveedor=${proveedorActual.idProveedor}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            })
                .then(response => response.json())
                .then(data => {
                    if (data.error) {
                        toast.error(data.error);
                    } else {
                        Swal.fire('¡Actualizado!', data.mensaje, 'success');
                        cargarProveedores();
                        cerrarModal();
                    }
                })
                .catch(error => toast.error(error.message));
        } else {
            // Crear
            const formData = new FormData();
            formData.append('nombre', nombre);
            formData.append('correo', correo);
            formData.append('telefono', telefono);
            formData.append('direccion', direccion);

            fetch(`${baseURL}/inventarioProveedoresPost.php`, {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    if (data.error) {
                        toast.error(data.error);
                    } else {
                        Swal.fire('¡Creado!', data.mensaje, 'success');
                        cargarProveedores();
                        cerrarModal();
                    }
                })
                .catch(error => toast.error(error.message));
        }
    };

    const eliminarProveedor = (idProveedor) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#D83098',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/inventarioProveedoresDelete.php?idProveedor=${idProveedor}`, {
                    method: 'DELETE'
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error) {
                            Swal.fire('Error', data.error, 'error');
                        } else {
                            Swal.fire('¡Eliminado!', data.mensaje, 'success');
                            cargarProveedores();
                        }
                    })
                    .catch(error => toast.error(error.message));
            }
        });
    };

    const proveedoresFiltrados = proveedores.filter(item =>
        item.nombre.toLowerCase().includes(filtro.toLowerCase()) ||
        (item.correo && item.correo.toLowerCase().includes(filtro.toLowerCase())) ||
        (item.telefono && item.telefono.includes(filtro))
    );

    return (
        <div>
            

            <div className='deFlexContent'>
                <button className='btnPost' onClick={abrirModalNuevo}>
                    <FontAwesomeIcon icon={faPlus} /> Agregar Proveedor
                </button>

                <div className='filtrosContain' style={{justifyContent: 'flex-end' }}>
                    <input
                        type="text"
                        placeholder="Buscar por nombre, correo o teléfono"
                        value={filtro}
                        onChange={(e) => setFiltro(e.target.value)}
                        className='filtroInput'
                    />
                    
                </div>
            </div>

            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <h3>{proveedorActual.idProveedor ? 'Editar Proveedor' : 'Nuevo Proveedor'}</h3>
                            <span className="close" onClick={cerrarModal}>&times;</span>
                        </div>

                        <div className='flexGrap'>
                            <fieldset>
                                <legend>Nombre *</legend>
                                <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
                            </fieldset>
                            <fieldset>
                                <legend>Correo electrónico</legend>
                                <input type="email" value={correo} onChange={(e) => setCorreo(e.target.value)} />
                            </fieldset>
                            <fieldset>
                                <legend>Teléfono</legend>
                                <input type="text" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
                            </fieldset>
                            <fieldset id='descripcion'>
                                <legend>Dirección</legend>
                                <textarea value={direccion} onChange={(e) => setDireccion(e.target.value)} />
                            </fieldset>
                        </div>

                        <button className='btnPost' onClick={guardarProveedor}>Guardar</button>
                    </div>
                </div>
            )}

            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>Correo</th>
                            <th>Teléfono</th>
                            <th>Dirección</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {proveedoresFiltrados.map(item => (
                            <tr key={item.idProveedor}>
                                <td>{item.idProveedor}</td>
                                <td>{item.nombre}</td>
                                <td>{item.correo || '-'}</td>
                                <td>{item.telefono || '-'}</td>
                                <td>{item.direccion || '-'}</td>
                                <td>
                                    <button className='editar' onClick={() => abrirModalEditar(item)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                    <button className='eliminar' onClick={() => eliminarProveedor(item.idProveedor)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}





